const SUBPAGE_NAV_WRAPPER_ID = '#subpage-navigation-wrapper';
const SUBPAGE_NAV_ID = '#subpage-navigation';
const HEADER_HEIGHT_VAR = '--header-height';
const SUBPAGE_NAV_HEIGHT_VAR = '--subpage-nav-height';
const STICKY_TOP_CLASS = 'top-header';



const subpageNavigationWrapper = document.querySelector(SUBPAGE_NAV_WRAPPER_ID);
const subpageNavigation = document.querySelector(SUBPAGE_NAV_ID);

const headerHeightPx = parseFloat(getComputedStyle(document.documentElement).getPropertyValue(HEADER_HEIGHT_VAR)) || 0;



let isStuck = false;

const observer = new IntersectionObserver(([entry]) => {
    const isIntersecting = entry.isIntersecting;
    const hasPassedHeader = entry.boundingClientRect.top < headerHeightPx;

    if (isStuck && (isIntersecting || !hasPassedHeader)) {
        subpageNavigation.classList.remove('fixed', STICKY_TOP_CLASS, 'inset-x-0', 'z-40');
        subpageNavigation.classList.add('relative');
        subpageNavigationWrapper.style.minHeight = `0px`;
        isStuck = false;
    } else if (!isStuck && !isIntersecting && hasPassedHeader) {
        const navHeight = subpageNavigation.getBoundingClientRect().height;
        subpageNavigationWrapper.style.minHeight = `${navHeight}px`;
        subpageNavigation.classList.remove('relative');
        subpageNavigation.classList.add('fixed', STICKY_TOP_CLASS, 'inset-x-0', 'z-40');
        isStuck = true;
    }
},{
    root: null,
    threshold: [1],
    rootMargin: `-${headerHeightPx}px 0px 0px 0px`,
});

const setNavScrollOffset = () => {
    if (subpageNavigation) {
        const navHeight = subpageNavigation.getBoundingClientRect().height;
        document.documentElement.style.setProperty(SUBPAGE_NAV_HEIGHT_VAR, `${navHeight}px`);
    }
};

if (document.fonts) {
    document.fonts.ready.then(setNavScrollOffset);
}

if (subpageNavigationWrapper) {
    observer.observe(subpageNavigationWrapper);
}

window.addEventListener('resize', () => requestAnimationFrame(setNavScrollOffset));
